import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { ScrollSmoother } from 'gsap/ScrollSmoother';
import lottie from 'lottie-web';
// import useWheelTrigger from '@/js/components/useWheelTrigger';
import BaseComponent from './baseComponent';

gsap.registerPlugin(ScrollTrigger);

export default class GoalBasedAdvisoryIntro extends BaseComponent {
  /**
   * Public constructor
   *
   * @param options
   */
  constructor(options) {
    super(options);
    this.el = document.querySelector('[data-goal-based-advisory-intro]');
    this.isIOS = (() => {
      try {
        return (
          [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod',
          ].includes(navigator.platform)
          || (navigator.userAgent.includes('Mac')
            && 'ontouchend' in document
            && navigator.maxTouchPoints > 2)
        );
      } catch (error) {
        return false;
      }
    })();
  }

  init() {
    if (!this.el) {
      return;
    }

    // Hide body to reset scroll position when page is reloaded
    // Beforeunload is not working on iOS, thats why we need to have this extra code.
    const eventName = this.isIOS ? 'pagehide' : 'beforeunload';
    window.addEventListener(eventName, () => {
      document.body.style.display = 'none';
    });

    // Remove #content-fullbackground from url when intro/slider is skipped
    window.addEventListener('hashchange', () => {
      setTimeout(() => {
        ScrollTrigger.refresh();

        const event = new CustomEvent('refresh-scrolltrigger');
        window.dispatchEvent(event);
      }, 400);

      if (window.location.hash === '#content-fullbackground') {
        const noHashURL = window.location.href.replace(/#.*$/, '');
        window.history.replaceState('', document.title, noHashURL);
      }
    });

    const lottieElement = document.getElementById('gba-lottie');

    if (lottieElement) {
      // this.addLottieResize(lottieElement);
      this.LottieScrollTrigger(lottieElement, '/themes/custom/vpbank/templates/include/goal-based-advisory/gba-scroll-noeasing.json');
    }
  }

  // addLottieResize(player) {
  //   window.addEventListener('resize', () => {
  //     player.resize();
  //   });
  //
  //   return this;
  // }

  LottieScrollTrigger(target, path) {
    // helper function see: https://gsap.com/docs/v3/HelperFunctions/helpers/LottieScrollTrigger/

    const playhead = { frame: 0 };

    const endPosition = 4000;

    // we need two scrolltriggers (one for lottie and one for text)
    // both should start at the same time
    const stBaseSettings = {
      trigger: '.goal-based-advisory',
      start: 'top top',
      fastScrollEnd: true,
      scrub: 0.01,
      end: () => `+=${endPosition}`,
    };

    // scrolltrigger for lottie, we can only use one pinned trigger
    const stLottie = {
      ...stBaseSettings,
      pin: true,
      pinSpacing: true,
    };

    // scrollTrigger for text
    const stContent = {
      ...stBaseSettings,
      pin: false,
    };

    // eslint-disable-next-line no-unused-vars,no-use-before-define
    // const trigger = useWheelTrigger(clickEnterSliderButton, {
    //   triggerY: 30,
    // });

    function onEndScrolling() {
      document.body.classList.add('scrollexperience-done');
      document.querySelector('.page-header').classList.add('-hidden-important');

      const isIOS = (() => {
        try {
          return (
            [
              'iPad Simulator',
              'iPhone Simulator',
              'iPod Simulator',
              'iPad',
              'iPhone',
              'iPod',
            ].includes(navigator.platform)
            || (navigator.userAgent.includes('Mac')
              && 'ontouchend' in document
              && navigator.maxTouchPoints > 2)
          );
        } catch (error) {
          return false;
        }
      })();

      // Hide overflow if not on iOS device (due to safari bugs)
      if (!isIOS) {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';

        // If the user scrolls too quickly, the lock may occur too far ahead. Therefore,
        // jump back to the slider's intro screen.
        const textOverlays = document.querySelector('[data-goal-based-advisory-text-overlays]');
        textOverlays.scrollIntoView();

        // We need to do this when users use a very fast scroll wheel.╚(•⌂•)╝
        setTimeout(() => {
          textOverlays.scrollIntoView();
        }, 50);

        setTimeout(() => {
          textOverlays.scrollIntoView();
        }, 150);

        setTimeout(() => {
          textOverlays.scrollIntoView();
        }, 500);
      }

      // // setTimeout(() => {
      // trigger.start();
      // // }, 800);

      // document.addEventListener('click', function removeTrigger() {
      //   trigger.stop();
      //   document.removeEventListener('click', removeTrigger);
      // });

      setTimeout(() => {
        const event = new CustomEvent('scrollexperience-done');
        window.dispatchEvent(event);
      }, 2000);
    }

    // function clickEnterSliderButton() {
    //   const buttonEnterSlider = document.querySelector('.startslider');
    //
    //   if (buttonEnterSlider) {
    //     buttonEnterSlider.click();
    //
    //     trigger.stop();
    //   }
    // }

    const animation = lottie.loadAnimation({
      container: target,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice', // use vertical and horizontal center of svg on resize
      },
    });

    const textTl = gsap.timeline({
      scrollTrigger: stContent,
    });

    const fadeOutStart = {
      scale: 1,
    };

    const fadeOutEnd = {
      scale: 0.8,
      autoAlpha: 0,
      duration: 1.6,
      ease: 'outQuart',
    };

    const fadeInStart = {
      scale: 1.2,
      autoAlpha: 0,
    };

    const fadeInEnd = {
      scale: 1,
      autoAlpha: 1,
      duration: 1.6,
      ease: 'outQuart',
    };

    // scroll down arrow indicator
    const scrollIndicator = document.getElementById('scroll-indicator');

    textTl
      .to(
        scrollIndicator,
        {
          autoAlpha: 0,
          ease: 'outQuart',
        },
        1,
      ) // scroll down indication
      .fromTo('#gba-title', fadeOutStart, fadeOutEnd, '+=3') // first heading (visible at start)
      .fromTo('#gba-text', fadeInStart, fadeInEnd, '+=1.8') // second text
      .to('#gba-text', fadeOutEnd, '+=6') // fadeout text
      .fromTo('.dive-in', { autoAlpha: 0 }, {
        autoAlpha: 1, ease: 'outQuart', duration: 1.6, delay: 10,
      }) // fadein dive-in with button
      .call(() => {
        onEndScrolling();
      })
      .to({}, { duration: 1.5 }); // don't leave instantly after dive-in animation ends

    animation.addEventListener('DOMLoaded', () => {
      const createTween = () => {
        animation.frameTween = gsap.to(playhead, {
          frame: animation.totalFrames - 1,
          ease: 'none',
          onUpdate: () => {
            animation.goToAndStop(playhead.frame, true);
          },
          scrollTrigger: stLottie,
        });

        return animation.frameTween;
      };

      const lottieTween = createTween();
      document.querySelector('button.startslider').addEventListener('click', () => {
        textTl.scrollTrigger.disable();
        textTl.scrollTrigger.scroll(textTl.scrollTrigger.start);

        lottieTween.scrollTrigger.disable();
        lottieTween.scrollTrigger.scroll(textTl.scrollTrigger.start);

        gsap.set(['#gba-title', '#gba-text', '#scroll-indicator'], {
          autoAlpha: 0,
        });

        gsap.set(['.goal-based-advisory .heroelement', '.goal-based-advisory .actions.dive-in'], {
          autoAlpha: 1,
        });
      });

      // in case there are any other ScrollTriggers on the page and
      // the loading of this Lottie asset caused layout changes
      ScrollTrigger.sort();
      ScrollTrigger.refresh();

      this.addCloudAnimation(document.getElementById('clouds'));
    });

    // Fix deadlock on reload when already scrolled

    window.addEventListener('load', () => {
      ScrollTrigger.refresh();
    });

    window.addEventListener('resize', () => {
      ScrollTrigger.refresh();
    });

    return animation;
  }

  addCloudAnimation(clouds) {
    // layer needs the name #clouds in after effects to be able to access it
    clouds?.classList.add('clouds-anim');

    return this;
  }
}
